<template>
  <div class="contenttopspaning">
      <RadioGroup v-model="reportRadio" class="row no-margin bg_light">
        <div v-if="configurations.default_report"  class="col-lg-4 equal_padding">
          <div class="newcard_box heightcard_box">
            <div class="filter_msg" v-if="!isDepotSet">
             “Select depot(s) filters to enable these reports“
            </div>
            <div class="newcardblock radiobox_grid">
              <Radio
                v-for="report in group1"
                :label="report.id"
                :disabled="!isDepotSet || isDisable(report.id)"
                @change="reportChange"
                v-bind:key="report.id">
                {{report.name}}
                <Info :reportHeaders="report.reportHeaders" />
                <div v-if="isDisable(report.id) && isDepotSet">
                    <span class="errortext">{{ disableMsg(report.id)['0'] || (disableMsg(report.id))[`${movementSet.id}`] }}</span>
                </div>
              </Radio>
            </div>
          </div>
        </div>
        <div v-if="configurations.default_report" class="col-lg-4 equal_padding">
          <div class="newcard_box heightcard_box">
            <div class="filter_msg" v-if="!(isDepotSet)">
             “Select depot(s) filters to enable these reports“
            </div>
             <div class="filter_msg" v-if="isTransporterSet">
             “Select All Transporter to enable these reports“
            </div>
            <div class="newcardblock radiobox_grid">
              <Radio
                v-for="report in group2"
                :label="report.id"
                :disabled="!(isDepotSet && !isTransporterSet) || isDisable(report.id)"
                @change="reportChange"
                v-bind:key="report.id">
                {{report.name}}
                <Info :reportHeaders="report.reportHeaders"/>
                <div v-if="dateFilterError && reportRadio===report.id">
                  <span class="errortext">{{$getErr("DATE_FILTER_ERROR")}}</span>
                </div>
                <div v-if="isDisable(report.id) && (!isTransporterSet && isDepotSet)">
                    <span class="errortext">{{ disableMsg(report.id)['0'] || (disableMsg(report.id))[`${movementSet.id}`] }}</span>
                </div>
              </Radio>
            </div>
          </div>
        </div>
        <div v-if="configurations.default_report" class="col-lg-4 equal_padding">
          <div class="newcard_box heightcard_box">
            <div class="filter_msg" v-if="isDepotSet">
             “Unselect/clear Depots(s) filter to enable these reports“
            </div>
            <div class="newcardblock radiobox_grid">
              <Radio
                v-for="report in group3"
                :label="report.id"
                :disabled="isDepotSet || isDisable(report.id)"
                @change="reportChange"
                v-bind:key="report.id">
                {{report.name}}
                <Info :reportHeaders="report.reportHeaders"/>
               <div v-if="isDisable(report.id) && !isDepotSet">
                    <span class="errortext">{{ disableMsg(report.id)['0'] || (disableMsg(report.id))[`${movementSet.id}`] }}</span>
                </div>
              </Radio>
            </div>
          </div>
        </div>
        <div v-if="configurations.freight_bill_report" class="col-lg-6 equal_padding">
          <div class="newcard_box heightcard_box">
            <div class="filter_msg" v-if="!isDepotSet">
             “Select depot(s) filters to enable these reports“
            </div>
            <div class="newcardblock radiobox_grid">
              <Radio
                v-for="report in group4"
                :label="report.id"
                :disabled="!isDepotSet || isDisable(report.id)"
                @change="reportChange"
                v-bind:key="report.id">
                {{report.name}}
                <Info :reportHeaders="report.reportHeaders" />
                <div v-if="isDisable(report.id) && isDepotSet">
                    <span class="errortext">{{ disableMsg(report.id)['0'] || (disableMsg(report.id))[`${movementSet.id}`] }}</span>
                </div>
              </Radio>
            </div>
          </div>
        </div>
        <div v-if="configurations.packing_report"  class="col-lg-6 equal_padding">
          <div class="newcard_box heightcard_box">
            <div class="filter_msg" v-if="isDepotSet">
             “Packing reports“
            </div>
            <div class="newcardblock radiobox_grid">
              <Radio
                v-for="report in group5"
                :label="report.id"
                @change="reportChange"
                v-bind:key="report.id">
                {{report.name}}
                <Info :reportHeaders="report.reportHeaders"/>
               <!-- <div v-if="isDisable(report.id) && !isDepotSet">
                    <span class="errortext">{{ disableMsg(report.id)['0'] || (disableMsg(report.id))[`${movementSet.id}`] }}</span>
                </div> -->
              </Radio>
            </div>
          </div>
        </div>
      </RadioGroup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reports, disableReports } from '@/constants/reportConstants';
import Info from './action/Info';

const { movementType } = require('pando-constants');

export default {
  props: ['isDepotSet', 'isTransporterSet', 'dateFilterError', 'resetRadio', 'movementSet'],
  components: {
    Info,
  },
  data() {
    return {
      reportRadio: 0,
      reports,
      movementType,
      disableReports,
    };
  },
  computed: {
    ...mapGetters({
      configurations: 'app/configurations',
    }),
    group1() {
      return this.reports.filter(report => (report.group.includes('1')) &&
      (report.feature ? this.$hasFeature(report.feature) : true) &&
      (report.permission ? this.$hasPermission(report.permission) : true));
    },
    group2() {
      return this.reports.filter(report => (report.group.includes('2')) &&
      (report.feature ? this.$hasFeature(report.feature) : true) &&
      (report.permission ? this.$hasPermission(report.permission) : true));
    },
    group3() {
      return this.reports.filter(report => (report.group.includes('3')) &&
      (report.feature ? this.$hasFeature(report.feature) : true) &&
      (report.permission ? this.$hasPermission(report.permission) : true));
    },
    group4() {
      return this.reports.filter(report => (report.group.includes('4')) &&
      (report.feature ? this.$hasFeature(report.feature) : true) &&
      (report.permission ? this.$hasPermission(report.permission) : true));
    },
    group5() {
      return this.reports.filter(report => (report.group.includes('5')) &&
      (report.feature ? this.$hasFeature(report.feature) : true) &&
      (report.permission ? this.$hasPermission(report.permission) : true));
    },
  },
  methods: {
    reportChange() {
      this.$emit('reportChange', this.reportRadio);
    },
    isDisable(reportId) {
      if (!this.movementSet) return false;
      return (this.disableReports.movementNotRequired.includes(reportId) && this.movementSet.id !== 0) ||
      (this.disableReports.primary.includes(reportId) && this.movementSet.id === this.movementType.PRIMARY) ||
      (this.disableReports.secondary.includes(reportId) && this.movementSet.id === this.movementType.SECONDARY) ||
      (this.disableReports.vendor.includes(reportId) && this.movementSet.id === this.movementType.INWARD) ||
      (this.disableReports.returns.includes(reportId) && this.movementSet.id === this.movementType.RETURN);
    },
    // eslint-disable-next-line consistent-return
    disableMsg(reportId) {
      const messages = {};
      if (this.disableReports.movementNotRequired.includes(reportId)) {
        messages['0'] = this.$getErr('MOVEMENT_NOT_REQUIRED');
      }
      if (this.disableReports.primary.includes(reportId)) {
        messages[`${this.movementType.PRIMARY}`] = this.$getErr('NOT_AVAILABLE_FOR_PRIMARY');
      }
      if (this.disableReports.secondary.includes(reportId)) {
        messages[`${this.movementType.SECONDARY}`] = this.$getErr('NOT_AVAILABLE_FOR_SECONDARY');
      }
      if (this.disableReports.vendor.includes(reportId)) {
        messages[`${this.movementType.INWARD}`] = this.$getErr('NOT_AVAILABLE_FOR_VENDOR');
      }
      if (this.disableReports.returns.includes(reportId)) {
        messages[`${this.movementType.RETURN}`] = this.$getErr('NOT_AVAILABLE_FOR_RETURNS');
      }
      return messages;
    },
  },
  watch: {
    resetRadio() {
      this.reportRadio = 0;
    },
  },
};
</script>
